import * as React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

export const ThemeCreateGraphic = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} inheritViewBox={true}>
      <svg
        {...props}
        viewBox="0 0 260 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_5054_4531)">
          <rect width="260" height="120" fill="#F5F7F7" />
          <g filter="url(#filter0_dd_5054_4531)">
            <rect
              x="-12.9453"
              y="-0.150024"
              width="134.396"
              height="126"
              rx="5.4"
              fill="#DFE3E3"
            />
            <rect
              x="-16"
              y="-2.84998"
              width="134.396"
              height="126"
              rx="5.4"
              fill="white"
            />
            <path
              d="M26.1001 31.7138C25.8973 31.7138 25.7296 31.706 25.597 31.6904C25.4722 31.6748 25.3474 31.6553 25.2226 31.6319C25.0978 31.6085 24.9457 31.589 24.7663 31.5734C24.5869 31.5578 24.3412 31.55 24.0292 31.55L23.6197 28.508H23.7601C23.8771 29.4674 24.1423 30.2084 24.5557 30.731C24.9769 31.2458 25.5151 31.5032 26.1703 31.5032C26.6539 31.5032 27.0478 31.3667 27.352 31.0937C27.6562 30.8207 27.8083 30.4658 27.8083 30.029C27.8083 29.8418 27.7732 29.6624 27.703 29.4908C27.6406 29.3192 27.5314 29.1359 27.3754 28.9409C27.2194 28.7459 27.0127 28.5353 26.7553 28.3091C26.4979 28.0751 26.1781 27.8138 25.7959 27.5252L25.3162 27.1625C24.7312 26.7179 24.3256 26.3201 24.0994 25.9691C23.8732 25.6181 23.7601 25.2359 23.7601 24.8225C23.7601 24.1361 24.0097 23.5979 24.5089 23.2079C25.0159 22.8101 25.6828 22.6112 26.5096 22.6112C26.7124 22.6112 26.8762 22.619 27.001 22.6346C27.1336 22.6502 27.2584 22.6697 27.3754 22.6931C27.5002 22.7165 27.6445 22.736 27.8083 22.7516C27.9721 22.7672 28.1827 22.775 28.4401 22.775L28.5571 25.1384H28.4401C28.3309 24.413 28.0969 23.8397 27.7381 23.4185C27.3793 22.9973 26.9464 22.7867 26.4394 22.7867C26.0806 22.7867 25.792 22.892 25.5736 23.1026C25.363 23.3132 25.2577 23.594 25.2577 23.945C25.2577 24.2492 25.3552 24.5417 25.5502 24.8225C25.753 25.0955 26.1001 25.4153 26.5915 25.7819L27.0946 26.1563C27.6094 26.5307 28.015 26.8778 28.3114 27.1976C28.6156 27.5096 28.834 27.8138 28.9666 28.1102C29.0992 28.4066 29.1655 28.7225 29.1655 29.0579C29.1655 29.5727 29.0368 30.029 28.7794 30.4268C28.522 30.8246 28.1632 31.1366 27.703 31.3628C27.2506 31.5812 26.7163 31.6982 26.1001 31.7138ZM34.0656 31.8776L34.0539 30.3683C33.8511 30.7661 33.543 31.0898 33.1296 31.3394C32.7162 31.589 32.2794 31.7138 31.8192 31.7138C31.2966 31.7138 30.8754 31.5422 30.5556 31.199C30.2436 30.8558 30.0876 30.4034 30.0876 29.8418V26.6594C30.0876 26.363 30.0291 26.1329 29.9121 25.9691C29.7951 25.8053 29.5377 25.7234 29.1399 25.7234V25.6064H30.3216C30.7194 25.6064 31.0236 25.5635 31.2342 25.4777C31.4292 25.3919 31.5657 25.2866 31.6437 25.1618H31.7607V29.9588C31.7607 30.3488 31.8387 30.6608 31.9947 30.8948C32.1507 31.1288 32.3535 31.2458 32.6031 31.2458C32.8449 31.2458 33.0945 31.1444 33.3519 30.9416C33.6093 30.731 33.8355 30.4502 34.0305 30.0992V26.6594C34.0305 26.3786 33.9603 26.1524 33.8199 25.9808C33.6795 25.8092 33.4377 25.7234 33.0945 25.7234V25.6064H34.2762C34.674 25.6064 34.9782 25.5635 35.1888 25.4777C35.3916 25.3919 35.532 25.2866 35.61 25.1618H35.727L35.7153 30.497C35.7153 30.7778 35.8011 31.0079 35.9727 31.1873C36.1443 31.3589 36.3705 31.4447 36.6513 31.4447V31.55H35.493C35.2902 31.55 35.1108 31.5539 34.9548 31.5617C34.7988 31.5773 34.6701 31.5929 34.5687 31.6085C34.3581 31.6553 34.2099 31.745 34.1241 31.8776H34.0656ZM36.5262 31.55V31.433H36.5379C36.8187 31.433 37.0449 31.3472 37.2165 31.1756C37.3881 31.004 37.4739 30.7778 37.4739 30.497V26.6594C37.4739 26.363 37.4115 26.1329 37.2867 25.9691C37.1697 25.8053 36.9162 25.7234 36.5262 25.7234V25.6064H37.6845C38.0043 25.6064 38.25 25.5908 38.4216 25.5596C38.601 25.5284 38.7336 25.4894 38.8194 25.4426C38.9052 25.388 38.9676 25.3334 39.0066 25.2788H39.1236L39.1353 26.7998C39.3381 26.3942 39.6462 26.0666 40.0596 25.817C40.473 25.5674 40.9098 25.4426 41.37 25.4426C41.8146 25.4426 42.1851 25.5674 42.4815 25.817C42.7779 26.0666 42.969 26.402 43.0548 26.8232C43.2732 26.402 43.5852 26.0666 43.9908 25.817C44.4042 25.5674 44.8488 25.4426 45.3246 25.4426C45.8472 25.4426 46.2645 25.6142 46.5765 25.9574C46.8963 26.3006 47.0562 26.753 47.0562 27.3146V30.497C47.0562 30.7778 47.142 31.004 47.3136 31.1756C47.4852 31.3472 47.7114 31.433 47.9922 31.433H48.0039V31.55H44.4354V31.433H44.4471C44.7279 31.433 44.9541 31.3472 45.1257 31.1756C45.2973 31.004 45.3831 30.7778 45.3831 30.497V27.1976C45.3831 26.8076 45.3051 26.4956 45.1491 26.2616C44.9931 26.0276 44.7903 25.9106 44.5407 25.9106C44.2989 25.9106 44.0454 26.0198 43.7802 26.2382C43.515 26.4488 43.2849 26.7257 43.0899 27.0689C43.0977 27.0845 43.1016 27.104 43.1016 27.1274C43.1016 27.1508 43.1016 27.1703 43.1016 27.1859V30.497C43.1016 30.7778 43.1874 31.004 43.359 31.1756C43.5306 31.3472 43.7568 31.433 44.0376 31.433H44.0493V31.55H40.4808V31.433H40.4925C40.7733 31.433 40.9995 31.3472 41.1711 31.1756C41.3427 31.004 41.4285 30.7778 41.4285 30.497V27.1976C41.4285 26.8076 41.3505 26.4956 41.1945 26.2616C41.0463 26.0276 40.8474 25.9106 40.5978 25.9106C40.356 25.9106 40.1025 26.0159 39.8373 26.2265C39.5799 26.4293 39.3537 26.7062 39.1587 27.0572V30.497C39.1587 30.7778 39.2445 31.004 39.4161 31.1756C39.5877 31.3472 39.8139 31.433 40.0947 31.433H40.1064V31.55H36.5262ZM47.8605 31.55V31.433H47.8722C48.153 31.433 48.3792 31.3472 48.5508 31.1756C48.7224 31.004 48.8082 30.7778 48.8082 30.497V26.6594C48.8082 26.363 48.7458 26.1329 48.621 25.9691C48.504 25.8053 48.2505 25.7234 47.8605 25.7234V25.6064H49.0188C49.3386 25.6064 49.5843 25.5908 49.7559 25.5596C49.9353 25.5284 50.0679 25.4894 50.1537 25.4426C50.2395 25.388 50.3019 25.3334 50.3409 25.2788H50.4579L50.4696 26.7998C50.6724 26.3942 50.9805 26.0666 51.3939 25.817C51.8073 25.5674 52.2441 25.4426 52.7043 25.4426C53.1489 25.4426 53.5194 25.5674 53.8158 25.817C54.1122 26.0666 54.3033 26.402 54.3891 26.8232C54.6075 26.402 54.9195 26.0666 55.3251 25.817C55.7385 25.5674 56.1831 25.4426 56.6589 25.4426C57.1815 25.4426 57.5988 25.6142 57.9108 25.9574C58.2306 26.3006 58.3905 26.753 58.3905 27.3146V30.497C58.3905 30.7778 58.4763 31.004 58.6479 31.1756C58.8195 31.3472 59.0457 31.433 59.3265 31.433H59.3382V31.55H55.7697V31.433H55.7814C56.0622 31.433 56.2884 31.3472 56.46 31.1756C56.6316 31.004 56.7174 30.7778 56.7174 30.497V27.1976C56.7174 26.8076 56.6394 26.4956 56.4834 26.2616C56.3274 26.0276 56.1246 25.9106 55.875 25.9106C55.6332 25.9106 55.3797 26.0198 55.1145 26.2382C54.8493 26.4488 54.6192 26.7257 54.4242 27.0689C54.432 27.0845 54.4359 27.104 54.4359 27.1274C54.4359 27.1508 54.4359 27.1703 54.4359 27.1859V30.497C54.4359 30.7778 54.5217 31.004 54.6933 31.1756C54.8649 31.3472 55.0911 31.433 55.3719 31.433H55.3836V31.55H51.8151V31.433H51.8268C52.1076 31.433 52.3338 31.3472 52.5054 31.1756C52.677 31.004 52.7628 30.7778 52.7628 30.497V27.1976C52.7628 26.8076 52.6848 26.4956 52.5288 26.2616C52.3806 26.0276 52.1817 25.9106 51.9321 25.9106C51.6903 25.9106 51.4368 26.0159 51.1716 26.2265C50.9142 26.4293 50.688 26.7062 50.493 27.0572V30.497C50.493 30.7778 50.5788 31.004 50.7504 31.1756C50.922 31.3472 51.1482 31.433 51.429 31.433H51.4407V31.55H47.8605ZM62.1577 31.6904C61.6195 31.6904 61.1398 31.5578 60.7186 31.2926C60.3052 31.0274 59.9815 30.6608 59.7475 30.1928C59.5135 29.717 59.3965 29.1749 59.3965 28.5665C59.3965 27.9425 59.5252 27.3965 59.7826 26.9285C60.04 26.4605 60.391 26.0978 60.8356 25.8404C61.288 25.5752 61.7989 25.4426 62.3683 25.4426C62.8441 25.4426 63.2653 25.5362 63.6319 25.7234C64.0063 25.9106 64.3027 26.1758 64.5211 26.519C64.7473 26.8544 64.876 27.2444 64.9072 27.689L64.9189 27.8645H60.9877V27.923C60.9877 28.7498 61.171 29.4128 61.5376 29.912C61.9042 30.4034 62.3956 30.6491 63.0118 30.6491C63.3862 30.6491 63.7411 30.5594 64.0765 30.38C64.4197 30.1928 64.6966 29.9432 64.9072 29.6312L65.0125 29.6663C64.8799 30.0641 64.6732 30.4151 64.3924 30.7193C64.1116 31.0235 63.7801 31.2614 63.3979 31.433C63.0157 31.6046 62.6023 31.6904 62.1577 31.6904ZM60.9994 27.689H63.3745C63.3745 27.0728 63.2731 26.5736 63.0703 26.1914C62.8753 25.8092 62.5984 25.6181 62.2396 25.6181C61.8964 25.6181 61.6117 25.8053 61.3855 26.1797C61.1593 26.5541 61.0306 27.0572 60.9994 27.689ZM65.0678 31.55V31.433H65.0795C65.3603 31.433 65.5865 31.3472 65.7581 31.1756C65.9297 31.004 66.0155 30.7778 66.0155 30.497V26.6594C66.0155 26.363 65.9531 26.1329 65.8283 25.9691C65.7113 25.8053 65.4578 25.7234 65.0678 25.7234V25.6064H66.2261C66.6395 25.6064 66.9515 25.5674 67.1621 25.4894C67.3727 25.4036 67.5209 25.2944 67.6067 25.1618H67.6652L67.6769 27.0806C67.7783 26.8466 67.907 26.6009 68.063 26.3435C68.2268 26.0861 68.4296 25.8716 68.6714 25.7C68.921 25.5206 69.2174 25.4309 69.5606 25.4309C69.6776 25.4309 69.8024 25.4426 69.935 25.466C70.0676 25.4894 70.208 25.5323 70.3562 25.5947L69.8999 26.9636C69.6191 26.8076 69.3734 26.6984 69.1628 26.636C68.96 26.5736 68.7806 26.5424 68.6246 26.5424C68.3594 26.5424 68.1605 26.6243 68.0279 26.7881C67.9031 26.9519 67.7939 27.1469 67.7003 27.3731V30.497C67.7003 30.7778 67.7861 31.004 67.9577 31.1756C68.1293 31.3472 68.3555 31.433 68.6363 31.433H68.648V31.55H65.0678ZM75.1996 31.7138C74.9968 31.7138 74.8447 31.706 74.7433 31.6904C74.6419 31.6748 74.5444 31.6553 74.4508 31.6319C74.365 31.6085 74.248 31.589 74.0998 31.5734C73.9516 31.5578 73.7254 31.55 73.4212 31.55L73.1404 29.3504H73.2925C73.4173 30.0836 73.6513 30.6374 73.9945 31.0118C74.3377 31.3784 74.7121 31.5617 75.1177 31.5617C75.5155 31.5617 75.8158 31.4798 76.0186 31.316C76.2292 31.1522 76.3345 30.9299 76.3345 30.6491C76.3345 30.4697 76.2877 30.3137 76.1941 30.1811C76.1083 30.0407 75.9562 29.9003 75.7378 29.7599C75.5194 29.6117 75.223 29.4362 74.8486 29.2334L74.5093 29.0462C74.0803 28.8044 73.7605 28.5236 73.5499 28.2038C73.3471 27.8762 73.2457 27.5252 73.2457 27.1508C73.2457 26.6204 73.4368 26.2031 73.819 25.8989C74.209 25.5947 74.7277 25.4426 75.3751 25.4426C75.5389 25.4426 75.6715 25.4504 75.7729 25.466C75.8743 25.4816 75.9718 25.5011 76.0654 25.5245C76.159 25.5479 76.276 25.5674 76.4164 25.583C76.5568 25.5986 76.744 25.6064 76.978 25.6064L77.1418 27.4901H77.0014C76.9546 27.1235 76.8493 26.7998 76.6855 26.519C76.5295 26.2304 76.3423 26.0081 76.1239 25.8521C75.9055 25.6883 75.6832 25.6064 75.457 25.6064C75.1606 25.6064 74.9227 25.6844 74.7433 25.8404C74.5717 25.9964 74.4859 26.2148 74.4859 26.4956C74.4859 26.7062 74.5522 26.9012 74.6848 27.0806C74.8252 27.2522 75.0904 27.4394 75.4804 27.6422L75.8314 27.8177C76.3774 28.0985 76.7752 28.391 77.0248 28.6952C77.2744 28.9994 77.3992 29.3894 77.3992 29.8652C77.3992 31.082 76.666 31.6982 75.1996 31.7138ZM79.6224 31.7138C79.1466 31.7138 78.7644 31.5851 78.4758 31.3277C78.1872 31.0703 78.0429 30.731 78.0429 30.3098C78.0429 30.1304 78.0741 29.9627 78.1365 29.8067C78.1989 29.6429 78.3159 29.483 78.4875 29.327C78.6669 29.171 78.9126 29.0111 79.2246 28.8473C79.5366 28.6757 79.95 28.4963 80.4648 28.3091L81.5529 27.9113V27.0338C81.5529 26.5892 81.4827 26.2382 81.3423 25.9808C81.2019 25.7156 81.0069 25.583 80.7573 25.583C80.4609 25.5908 80.2074 25.7858 79.9968 26.168C79.794 26.5502 79.6575 27.0806 79.5873 27.7592L78.3237 27.0338C78.4563 26.714 78.6591 26.4332 78.9321 26.1914C79.2051 25.9496 79.5171 25.7624 79.8681 25.6298C80.2269 25.4972 80.6013 25.4309 80.9913 25.4309C81.6543 25.4309 82.1925 25.6181 82.6059 25.9925C83.0271 26.3591 83.2377 26.8622 83.2377 27.5018V30.3215C83.2377 30.7739 83.3898 31.0001 83.694 31.0001C83.8734 31.0001 84.0489 30.9026 84.2205 30.7076L84.3141 30.7895C84.1113 31.0625 83.8656 31.2848 83.577 31.4564C83.2884 31.628 83.0076 31.7138 82.7346 31.7138C82.4382 31.7138 82.1808 31.6124 81.9624 31.4096C81.7518 31.2068 81.6192 30.9377 81.5646 30.6023C81.1824 30.9923 80.847 31.277 80.5584 31.4564C80.2776 31.628 79.9656 31.7138 79.6224 31.7138ZM80.4999 30.9884C80.6715 30.9884 80.8353 30.9455 80.9913 30.8597C81.1551 30.7739 81.3384 30.6335 81.5412 30.4385L81.5529 28.0634L81.0849 28.2389C80.6871 28.3871 80.3829 28.5392 80.1723 28.6952C79.9617 28.8434 79.8135 29.0111 79.7277 29.1983C79.6497 29.3855 79.6107 29.6 79.6107 29.8418C79.6107 30.1772 79.6926 30.4541 79.8564 30.6725C80.028 30.8831 80.2425 30.9884 80.4999 30.9884ZM84.1243 31.55V31.433C84.4051 31.433 84.6313 31.3511 84.8029 31.1873C84.9823 31.0157 85.072 30.7856 85.072 30.497V23.828C85.072 23.5472 84.9823 23.321 84.8029 23.1494C84.6313 22.9778 84.4051 22.892 84.1243 22.892V22.775H85.3177C85.7155 22.775 86.0197 22.7321 86.2303 22.6463C86.4253 22.5605 86.5618 22.4552 86.6398 22.3304H86.7568V30.497C86.7568 30.7856 86.8426 31.0157 87.0142 31.1873C87.1936 31.3511 87.4237 31.433 87.7045 31.433V31.55H84.1243ZM90.4823 31.6904C89.9441 31.6904 89.4644 31.5578 89.0432 31.2926C88.6298 31.0274 88.3061 30.6608 88.0721 30.1928C87.8381 29.717 87.7211 29.1749 87.7211 28.5665C87.7211 27.9425 87.8498 27.3965 88.1072 26.9285C88.3646 26.4605 88.7156 26.0978 89.1602 25.8404C89.6126 25.5752 90.1235 25.4426 90.6929 25.4426C91.1687 25.4426 91.5899 25.5362 91.9565 25.7234C92.3309 25.9106 92.6273 26.1758 92.8457 26.519C93.0719 26.8544 93.2006 27.2444 93.2318 27.689L93.2435 27.8645H89.3123V27.923C89.3123 28.7498 89.4956 29.4128 89.8622 29.912C90.2288 30.4034 90.7202 30.6491 91.3364 30.6491C91.7108 30.6491 92.0657 30.5594 92.4011 30.38C92.7443 30.1928 93.0212 29.9432 93.2318 29.6312L93.3371 29.6663C93.2045 30.0641 92.9978 30.4151 92.717 30.7193C92.4362 31.0235 92.1047 31.2614 91.7225 31.433C91.3403 31.6046 90.9269 31.6904 90.4823 31.6904ZM89.324 27.689H91.6991C91.6991 27.0728 91.5977 26.5736 91.3949 26.1914C91.1999 25.8092 90.923 25.6181 90.5642 25.6181C90.221 25.6181 89.9363 25.8053 89.7101 26.1797C89.4839 26.5541 89.3552 27.0572 89.324 27.689Z"
              fill="#5E5E5E"
            />
            <rect
              x="12.5498"
              y="40.35"
              width="93.6"
              height="39.6"
              rx="1.8"
              fill="#EFF1F1"
            />
            <rect
              x="36.8506"
              y="54.75"
              width="9"
              height="4.5"
              rx="1.8"
              fill="#DFDFDF"
            />
            <rect
              x="30.5498"
              y="60.15"
              width="21.6"
              height="11.7"
              rx="1.8"
              fill="#DFDFDF"
            />
            <rect
              x="72.8506"
              y="51.15"
              width="7.2"
              height="5.4"
              rx="2.7"
              fill="#DFDFDF"
            />
            <path
              d="M70.6263 57.751C70.8803 57.0313 71.5605 56.55 72.3237 56.55H81.1283C81.9149 56.55 82.6104 57.0608 82.8458 57.8112L86.5164 69.5112C86.8802 70.6707 86.0141 71.85 84.7989 71.85H68.1943C66.9523 71.85 66.0835 70.6221 66.4969 69.451L70.6263 57.751Z"
              fill="#DFDFDF"
            />
            <rect
              x="55.75"
              y="47.55"
              width="6.3"
              height="9.9"
              rx="1.8"
              fill="#C9CDCD"
            />
            <rect
              x="48.5498"
              y="54.75"
              width="21.6"
              height="19.8"
              rx="1.8"
              fill="#C9CDCD"
            />
            <rect
              x="38.6504"
              y="105.15"
              width="41.4"
              height="9.9"
              rx="1.8"
              fill="#161616"
            />
            <rect
              x="21.5498"
              y="88.95"
              width="75.6"
              height="3.6"
              rx="1.8"
              fill="#E0E4E4"
            />
            <rect
              x="35.0498"
              y="96.1499"
              width="48.6"
              height="3.6"
              rx="1.8"
              fill="#E0E4E4"
            />
          </g>
          <g filter="url(#filter1_dd_5054_4531)">
            <rect
              x="145.01"
              y="-0.150024"
              width="132.44"
              height="126"
              rx="5.4"
              fill="#DFE3E3"
            />
            <rect
              x="142"
              y="-2.84998"
              width="132.44"
              height="126"
              rx="5.4"
              fill="white"
            />
            <rect
              x="154.6"
              y="20.55"
              width="57.6"
              height="15.3"
              rx="1.8"
              fill="#D9E4FB"
            />
            <rect
              x="154.6"
              y="79.9501"
              width="95.4"
              height="35.1"
              rx="1.8"
              fill="#D9E4FB"
            />
            <rect
              x="178.9"
              y="91.6499"
              width="9"
              height="4.5"
              rx="1.8"
              fill="#B9CCFF"
            />
            <rect
              x="172.6"
              y="97.05"
              width="21.6"
              height="11.7"
              rx="1.8"
              fill="#B9CCFF"
            />
            <rect
              x="214.9"
              y="88.05"
              width="7.2"
              height="5.4"
              rx="2.7"
              fill="#B9CCFF"
            />
            <path
              d="M212.677 94.6509C212.931 93.9312 213.611 93.45 214.374 93.45H223.179C223.965 93.45 224.661 93.9607 224.896 94.7111L228.567 106.411C228.93 107.571 228.064 108.75 226.849 108.75H210.245C209.003 108.75 208.134 107.522 208.547 106.351L212.677 94.6509Z"
              fill="#B9CCFF"
            />
            <rect
              x="197.801"
              y="84.45"
              width="6.3"
              height="9.9"
              rx="1.8"
              fill="#94B2FF"
            />
            <rect
              x="190.6"
              y="91.6499"
              width="21.6"
              height="19.8"
              rx="1.8"
              fill="#94B2FF"
            />
            <rect
              x="154.6"
              y="45.75"
              width="83.7"
              height="3.6"
              rx="1.8"
              fill="#C9D7FB"
            />
            <rect
              x="154.6"
              y="52.9501"
              width="43.2"
              height="3.6"
              rx="1.8"
              fill="#C9D7FB"
            />
            <rect
              x="154.6"
              y="61.05"
              width="36"
              height="9.9"
              rx="4.95"
              fill="#2962FF"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_dd_5054_4531"
            x="-28"
            y="-10.85"
            width="161.45"
            height="152.7"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="3" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_5054_4531"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="6" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
            />
            <feBlend
              mode="normal"
              in2="effect1_dropShadow_5054_4531"
              result="effect2_dropShadow_5054_4531"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect2_dropShadow_5054_4531"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_dd_5054_4531"
            x="130"
            y="-10.85"
            width="159.45"
            height="152.7"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="3" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_5054_4531"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="6" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
            />
            <feBlend
              mode="normal"
              in2="effect1_dropShadow_5054_4531"
              result="effect2_dropShadow_5054_4531"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect2_dropShadow_5054_4531"
              result="shape"
            />
          </filter>
          <clipPath id="clip0_5054_4531">
            <rect width="260" height="120" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};
